export const buildings = [], debris = [], fires = [], cityStatic = [];
export const gems = []; export const GEM_N = 16;
